import React from 'react';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import themeSVG from '@plone/volto/icons/theme.svg';

export default function addStyleMenuTextColors(config) {
  const { slate } = config.settings;

  slate.styleMenu = slate.styleMenu || {};
  slate.styleMenu.inlineStyles =
    slate.styleMenu.inlineStyles || [];

  slate.styleMenu.inlineStyles.push(
    {
      cssClass: 'text-color-default',
      label: 'Wildcard Default',
      icon: () => (
        <Icon name={themeSVG} size="24px" />
      ),
    },
    {
      cssClass: 'text-color-charcoal-slate',
      label: 'Wildcard Charcoal Slate',
      icon: () => (
        <Icon name={themeSVG} size="24px" />
      ),
    },
    {
      cssClass: 'text-color-light-green',
      label: 'Wildcard Light Green',
      icon: () => (
        <Icon name={themeSVG} size="24px" />
      ),
    },
    {
      cssClass: 'text-color-red',
      label: 'Wildcard Red',
      icon: () => (
        <Icon name={themeSVG} size="24px" />
      ),
    },
    {
      cssClass: 'text-color-dark-red',
      label: 'Wildcard Dark Red',
      icon: () => (
        <Icon name={themeSVG} size="24px" />
      ),
    },
  );

  return config;
}